<template>
  <div>
    <ItemHeader
      v-if="showRoot"
      :itemID="item._id"
      class="no-menu"
      defaultAction="open"
      :key="item._id"
    />
    <ItemHeader
      v-for="el in children"
      :key="el._id"
      :itemID="el._id"
      defaultAction="open"
      class="no-menu"
    />
    <div class="create-first" @click="createInMainView">
      <div class="md-icon">add</div>
      {{ addText }}
    </div>
  </div>
</template>

<style scoped>
.create-first {
  cursor: pointer;
  align-items: center;
  font-style: italic;
  display: flex;
  & .md-icon {
    padding: var(--basic-padding);
    opacity: var(--text-opacity-tertiary);
  }
  opacity: var(--text-opacity-tertiary);
}

.create-first {
  min-width: auto;
  padding-left: 8px;
}
.create-first:hover {
  background: var(--bg-color-hover);
}
</style>

<script>
import ItemHeader from "./ItemHeader.vue";
import { getItem } from "@/reactive-cache";

export default {
  props: ["itemType"],
  components: {
    ItemHeader,
  },
  data() {
    return {};
  },
  computed: {
    itemID() {
      return "root:" + this.itemType;
    },
    item() {
      return getItem(this.itemID);
    },
    addText() {
      switch (this.itemType) {
        case "period":
          return "Dodaj własny przedział czasu...";
        case "list":
          return `Dodaj nową listę...`;
        case "layout":
          return "Dodaj widok...";
        case "label":
          return "Dodaj etykietę...";
      }
    },
    children() {
      return this.item.getChildren();
    },
    showRoot() {
      return this.itemType !== "period";
    },
  },
  methods: {
    createInMainView(event) {
      if (
        this.itemID !== this.$route.params.itemID &&
        this.item.getChildren().length === 0
      ) {
        this.item.open(event);
      } else {
        this.createChild();
      }
    },
    createChild() {
      this.item.createChild(this.itemType, `Nazwa:`);
    },
  },
};
</script>
